module.exports = __webpack_public_path__ + "img/86.7de885ea.jpg";